export const USER_TRACKING_COOKIE_NAME = "tracking_params";
export const USER_TRACKING_COOKIE_EXPIRATION_DAYS = 1;
export const GCLID_SOURCE = "Google";
export const GCLID_MEDIUM = "cpc";
